import React, { useState, useEffect } from 'react';
import { bool, func, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import routeConfiguration from '../../routing/routeConfiguration';
import { ensureCurrentUser } from '../../util/data';
import { propTypes } from '../../util/types';
import { pathByRouteName } from '../../util/routes';
import { Modal } from '..';

import EmailReminder from './EmailReminder';

import css from './BarMissingInformation.module.css';

const MISSING_INFORMATION_MODAL_WHITELIST = [
  'LoginPage',
  'SignupPage',
  'ContactDetailsPage',
  'EmailVerificationPage',
  'PasswordResetPage',
  'ShopDetailsPage',
  'ManageShippingPage',
  'ManageShippingRangesPage',
];

const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
const SHIPPING_DETAILS = 'SHIPPING_DETAILS';

const BarMissingInformation = ({
  rootClassName,
  className,
  currentUser,
  sendVerificationEmailInProgress,
  sendVerificationEmailError,
  onResendVerificationEmail,
  currentUserHasListings,
  currentUserHasOrders,
  location,
}) => {
  const [showMissingInformationReminder, setShowMissingInformationReminder] = useState(null);

  useEffect(() => {
    const user = ensureCurrentUser(currentUser);
    handleMissingInformationReminder(
      user,
      currentUserHasListings,
      currentUserHasOrders,
      location
    );
  }, [currentUser, currentUserHasListings, currentUserHasOrders, location]);

  const handleMissingInformationReminder = (
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    newLocation
  ) => {
    const routes = routeConfiguration();
    const whitelistedPaths = MISSING_INFORMATION_MODAL_WHITELIST.map(page =>
      pathByRouteName(page, routes)
    );

    // Is the current page whitelisted?
    const isPageWhitelisted = false; // whitelistedPaths.includes(newLocation.pathname);

    if (!isPageWhitelisted) {
      const emailUnverified = (!!currentUser.id && !currentUser.attributes.emailVerified) || currentUser?.attributes.pendingEmail ; 
      const emailVerificationNeeded = emailUnverified;
      // Show reminder
      if (emailVerificationNeeded) {
        setShowMissingInformationReminder(EMAIL_VERIFICATION);
      }
    }
  };

  const user = ensureCurrentUser(currentUser);
  const classes = classNames(rootClassName || css.root, className, css.emailMissingInformationContainer);

  let content = null;

  const currentUserLoaded = user && user.id;
  if (currentUserLoaded) {
    if (showMissingInformationReminder === EMAIL_VERIFICATION) {
      content = (
        <EmailReminder
          className={classes}
          user={user}
          onResendVerificationEmail={onResendVerificationEmail}
          sendVerificationEmailInProgress={sendVerificationEmailInProgress}
          sendVerificationEmailError={sendVerificationEmailError}
        />
      );
    }
  }

  return (
    <div>
      {content}
    </div>
  );
};

BarMissingInformation.propTypes = {
  id: string.isRequired,
  className: string,
  rootClassName: string,
  containerClassName: string,

  currentUser: propTypes.currentUser,
  onManageDisableScrolling: func.isRequired,
  sendVerificationEmailError: propTypes.error,
  sendVerificationEmailInProgress: bool.isRequired,
};

BarMissingInformation.displayName = 'BarMissingInformation';

export default BarMissingInformation;
